import { render, staticRenderFns } from "./OptionsGameplayTab.vue?vue&type=template&id=54a9d4e0&scoped=true&"
import script from "./OptionsGameplayTab.vue?vue&type=script&lang=js&"
export * from "./OptionsGameplayTab.vue?vue&type=script&lang=js&"
import style0 from "./OptionsGameplayTab.vue?vue&type=style&index=0&id=54a9d4e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9d4e0",
  null
  
)

export default component.exports